import { useEffect, useRef } from "react";
import s from "./ElleMurmura.module.scss";
import { gsap } from "gsap";
import { useTranslation } from "react-i18next";

const ElleMurmura = () => {
  const wrapperRef = useRef();
  const { t } = useTranslation();

  useEffect(() => {
    gsap.fromTo(
      wrapperRef.current,
      {
        opacity: 0,
        y: 100,
      },
      {
        opacity: 1,
        y: 0,
        scrollTrigger: {
          trigger: wrapperRef.current,
          start: "center bottom",
          end: "bottom top+=75%",
          // scrub: true,
          // markers: {},
        },
      }
    );
  }, []);

  return (
    <div ref={wrapperRef} className={s.wrapper}>
      <span className={s.elleMurmura}>Elle murmura</span>
      <h2 className={s.question}>Puis-je m'asseoir ?</h2>
      <p className={s.paragraph}>{t("ellemurmura.title")}</p>
    </div>
  );
};

export default ElleMurmura;
